import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import axios from "axios";

const Todayoffers = () => {
  const [leftAds, setLeftAds] = useState([]);
  const [rightAds, setRightAds] = useState([]);
  const [centerAds, setCenterAds] = useState([]);
  const [index, setIndex] = useState(0);
  const videoRef = useRef(null);
  const timerRef = useRef(null);

  // Fetch all ads on mount
  useEffect(() => {
    const fetchAds = async () => {
      try {
        const [leftRes, rightRes, centerRes] = await Promise.all([
          axios.get("https://api.bakpoket.com/api/TopBanner/TTC_Images/TTCoLeftMin"),
          axios.get("https://api.bakpoket.com/api/TopBanner/TTC_Images/TTCoRightMin"),
          axios.get("https://api.bakpoket.com/api/TopBanner/TTC_Images/TTCoMax"),
        ]);
        setLeftAds(leftRes.data || []);
        setRightAds(rightRes.data || []);
        setCenterAds(centerRes.data || []);
      } catch (err) {
        console.error("Error fetching ads:", err);
      }
    };
    fetchAds();
  }, []);

  // Handle next ad set
  const nextAdSet = () => {
    setIndex((prev) => (prev + 1) % Math.max(centerAds.length || 1));
  };

  // Control timing based on media type
  useEffect(() => {
    if (!centerAds.length) return;

    const currentAd = centerAds[index % centerAds.length];

    // Clear previous timers
    clearTimeout(timerRef.current);

    if (currentAd?.contentType?.includes("video")) {
      // Wait for video to finish
      const videoElement = videoRef.current;
      if (videoElement) {
        videoElement.onended = () => {
          nextAdSet();
        };
      }
    } else {
      // Image → wait 5 seconds then next
      timerRef.current = setTimeout(() => {
        nextAdSet();
      }, 5000);
    }

    return () => {
      clearTimeout(timerRef.current);
      if (videoRef.current) videoRef.current.onended = null;
    };
  }, [index, centerAds]);

  const leftAd = leftAds.length ? leftAds[index % leftAds.length] : null;
  const rightAd = rightAds.length ? rightAds[index % rightAds.length] : null;
  const centerAd = centerAds.length ? centerAds[index % centerAds.length] : null;

  return (
    <Wrapper>
      {/* Left Ad */}
      {leftAd && (
        <FadeWrapper key={`left-${index}`}>
          <a href={`https://${leftAd.merchantURL}`} target="_blank" rel="noopener noreferrer">
            <img
              className="img2"
              src={`data:image/png;base64,${leftAd.imageBase64}`}
              alt="Left Ad"
            />
          </a>
        </FadeWrapper>
      )}

      {/* Center Ad */}
      {centerAd && (
        <FadeWrapper key={`center-${index}`}>
          <a href={`https://${centerAd.merchantURL}`} target="_blank" rel="noopener noreferrer">
            {centerAd.contentType?.includes("video") ? (
              <video
                ref={videoRef}
                className="img1"
                autoPlay
                muted
                preload="auto"
                key={`video-${index}`}
              >
                <source
                  src={`data:video/mp4;base64,${centerAd.imageBase64}`}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                className="img1"
                src={`data:image/png;base64,${centerAd.imageBase64}`}
                alt="Center Ad"
              />
            )}
          </a>
        </FadeWrapper>
      )}

      {/* Right Ad */}
      {rightAd && (
        <FadeWrapper key={`right-${index}`}>
          <a href={`https://${rightAd.merchantURL}`} target="_blank" rel="noopener noreferrer">
            <img
              src={`data:image/png;base64,${rightAd.imageBase64}`}
              className="img2"
              alt="Right Ad"
            />
          </a>
        </FadeWrapper>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  max-width: 1280px;
  width: 100%;
  margin: 15px auto;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img, video {
    display: block;
    object-fit: contain;
  }

  .img1 {
    width: 100%;
    margin: 0px 7px;
  }

  .img2 {
    width: 100%;
  }

  @media (max-width: 1200px) {
    width: 90%;
    .img1 {
      margin: 0px ;
      padding: 0px 3px;
      height:100%;
    }
  }

  @media (max-width: 480px) {
    width: 90%;
    .img1 {
      margin: 0px ;
      padding: 0px 3px;
      height:100%;
    }
  }
`;

const FadeWrapper = styled.div`
  opacity: 0;
  animation: fadeIn 0.8s ease forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

export default Todayoffers;

